import slider from "../components/slider";

slider("promo-banner", {
    type: "carousel",
    hoverpause: true,
    perView: 2,
    breakpoints: {
        1000: {
            type: "slider",
            perView: 1,
            autoplay: 5000
        }
    }
});

const saveDiscount = document.querySelector(".js-save-discount");

if (saveDiscount) {
    saveDiscount.addEventListener("click", () => {
        const discountCode = saveDiscount.dataset.discount;
        if (discountCode) {
            window.localStorage.setItem("discount", discountCode);
        }
    });
}